<vy-header
  (langButtonClicked)="onLangButtonClicked()"
  (loggedButtonClicked)="onLoggedButtonClicked()"
  [linkButtonSkip]="'#main-content'"
  [cultureCurrency]=" currentCurrency()"
  [cultureLang]="getLanguageSelected()"
  [linkLogo]="linkLogo"
  [headerNavbarLinks]="this.headerNavbarLinks()"
  [logoName]="getLogoName() | translate"
  [headerStickyEnabled]="true"
  [linkRegister]="ticketsUrl"
  [headerNegative]="!isTransparent()"
  [headerProcess]="false"
  [headerTransparent]="isTransparent()"
  [isEnabledCulture]="true"
  [isEnabledBasket]="false"
  [setDynamicPadding]="!isTransparent()"
  [isLogged]="!!userInfo()?.userName"
  [nameAuth]="userInfo()?.userName ?? ''"
  [removeScrollOffset]="isTransparent()"
>
</vy-header>
